module.exports = __webpack_public_path__ + "img/changed-test.2d56743b.svg";